.filter-bar-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
}

.filter-bar-actions-wrapper {
  display: flex;
  flex-direction: row;
  min-height: 32px;
  padding: 5px 0;
  justify-content: space-between;
}

@media (max-width: 970px) {
  .filter-bar-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-bar-actions-wrapper {
    padding: 10px 0 5px 60px;
  }
}

.sidebar-toggle {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}
